"use client";

import React, { useState } from "react";
import { BASE_API_URL } from "../utils/constants";

type LinkPreviewData = {
  title?: string;
  description?: string;
  images?: string[];
  favicons?: string[];
  siteName?: string;
  type?: string;
  video?: string;
  audio?: string;
  url: string;
};

interface HoverLinkPreviewProps {
  url: string;
  className?: any
  children: React.ReactNode;
}

const HoverLinkPreview: React.FC<HoverLinkPreviewProps> = ({ url,className, children }) => {
  const [previewData, setPreviewData] = useState<LinkPreviewData | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleMouseEnter = async () => {
    setShowPreview(true);

    if (previewData || loading) return; // Already fetched or fetching

    setLoading(true);
    try {
      const response = await fetch(`${BASE_API_URL}libsense/link-preview`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch preview");
      }

      const data = await response.json();
      setPreviewData(data);
    } catch (error) {
      console.error("Failed to fetch preview:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMouseLeave = () => {
    setShowPreview(false);
  };

  return (
    <div className={`relative inline-block ${className}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
    <a href={url} target="_blank" rel="noopener noreferrer" className={` hover:underline ${className ? "text-foreground" : "text-primary"}`}>
        {children}
      </a>
      {showPreview && previewData && (
  <div className="absolute z-50 p-4 bg-white rounded-xl shadow-lg w-80 top-full mt-2 border">
    <div className="flex items-start space-x-4">
      {previewData.favicons && (
        <img
          src={previewData.favicons[0]}
          alt={previewData.title}
          className="rounded-md object-cover h-20 w-20 flex-shrink-0"
        />
      )}
      <div className="flex flex-col overflow-hidden">
        <h4 className="font-semibold text-sm truncate">{previewData.title}</h4>
        <p className="text-xs text-gray-500 mt-1 line-clamp-3">{previewData.description}</p>
      </div>
    </div>
  </div>
)}


      {showPreview && loading && (
        <div className="absolute z-50 p-4 bg-white rounded-xl shadow-lg w-64 top-full mt-2 border text-center">
          <div className="animate-pulse">Loading preview...</div>
        </div>
      )}
    </div>
  );
};

export default HoverLinkPreview;
